const fieldDisabled = (disableFlag, disableWhenField, formApi, fieldArray, is = undefined, type = undefined) => {
  if (disableWhenField !== "_section_f_f12_f13_f14_prevailing_wage_question" && type !== "checkbox") {
    const isIsArray = Array.isArray(is);
    const isdisableWhenFieldArray = Array.isArray(disableWhenField);

    if (
      fieldArray &&
      formApi.getFieldState(fieldArray) &&
      formApi.getFieldState(fieldArray).value &&
      formApi.getFieldState(fieldArray).value[0] &&
      formApi.getFieldState(fieldArray).value[0][disableWhenField] &&
      formApi.getFieldState(fieldArray).value[0][disableWhenField] !== "- Select -"
    ) {
      return false;
    } else if (disableWhenField && isdisableWhenFieldArray) {
      for (let check of disableWhenField) {
        if (check.when && check.isInlineModal) {
          return !formApi.getState().values.add_values_field?.[0] || formApi.getState().values.add_values_field?.[0]?.[check.when] === check.is;
        }
        const fieldValue = formApi.getState().values[check.when];
        if (check.when && Array.isArray(check.is)) {
          // If check.is is an array, check if field value is included in the array
          if (check.is.includes(fieldValue)) {
            return true;
          }
        } else if (check.when && fieldValue == check.is) {
          // Simple equality check for non-array check.is
          return true;
        }
      }
      return false; // If none of the conditions matched, return false
    } else if (
      disableWhenField &&
      disableWhenField.array &&
      // disableWhenField.is &&
      disableWhenField.when &&
      disableWhenField.property &&
      disableWhenField.operator
    ) {
      let section_f = formApi.getState().values[disableWhenField.when];
      let { operator, property, is } = disableWhenField;
      let _disabled = false;
      if (section_f && operator && property) {
        switch (operator) {
          case "any":
            section_f.forEach((item) => {
              if (isIsArray) {
                if (is.includes(item[property])) {
                  _disabled = true;
                }
              } else {
                if (is === item[property]) {
                  _disabled = true;
                }
              }
            });
        }
      }

      return _disabled;
    } else if (isIsArray && disableWhenField && is.includes(formApi.getState().values[disableWhenField])) {
      // if 'is' is Array and value of field to check is included in Array then mark field as disabled

      return true;
    } else if (
      disableWhenField &&
      // disableWhenField.is &&
      disableWhenField.when &&
      formApi.getState().values[disableWhenField.when] &&
      formApi.getState().values[disableWhenField.when] !== disableWhenField.is
    ) {
      return false;
    } else if (
      formApi.getFieldState(disableWhenField) &&
      formApi.getFieldState(disableWhenField).value &&
      formApi.getFieldState(disableWhenField).value !== "- Select -"
    ) {
      return false;
    } else if (
      formApi &&
      formApi.getState() &&
      formApi.getState().values &&
      formApi.getState().values[disableWhenField] &&
      formApi.getState().values[disableWhenField] !== is
    ) {
      return false;
    }  else {
      return true;
    }
  } else if (type === "checkbox") {
    if (
      formApi &&
      formApi.getState() &&
      formApi.getState().values
    ) {
      if (!Array.isArray(disableWhenField)) {
        if (formApi.getState().values[disableWhenField] !== is) {
          return false;
        } else {
          return true;
        }
      } else {
        let flag = false;
        disableWhenField.forEach(whenGroup => {
          if (!Array.isArray(whenGroup.is) && formApi.getState().values[whenGroup.when] === whenGroup.is) {
            flag = true;
          } else if (Array.isArray(whenGroup.is) && whenGroup.is.includes(formApi.getState().values[whenGroup.when])) {
            flag = true
          }
        })
        return flag
      }
    }
  } else {
    return !!(
      formApi &&
      formApi.getFieldState(disableWhenField) &&
      formApi.getFieldState(disableWhenField).value &&
      formApi.getFieldState(disableWhenField).value === is
    );
  }
};

export default fieldDisabled;
